import { render, staticRenderFns } from "./ProjectSettingsProjectType.vue?vue&type=template&id=8f1c29f0&scoped=true"
import script from "./ProjectSettingsProjectType.vue?vue&type=script&lang=js"
export * from "./ProjectSettingsProjectType.vue?vue&type=script&lang=js"
import style0 from "./ProjectSettingsProjectType.vue?vue&type=style&index=0&id=8f1c29f0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f1c29f0",
  null
  
)

export default component.exports